import { render } from "./JournalEntryTable.vue?vue&type=template&id=70cea29d"
import script from "./JournalEntryTable.vue?vue&type=script&lang=js"
export * from "./JournalEntryTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__